import { getLogger } from '@omnia/ui/src/lib/services/logger/logger.service'

export interface AnalyticsPayload {
    event: string
    params: Record<string, unknown>
    timestamp_micros?: number
    platform?: 'web' | 'app'
    engagement_time_msec?: number
    client_id?: string
    session_id?: number
    debounce_keys?: string[]
}

const TRACKING_TIMEOUT = 250

export class AnalyticsService {
    private initialized = false
    private queueProcessingTimeout: ReturnType<typeof setTimeout> | null = null

    protected logger: ReturnType<typeof getLogger>['value']
    protected queue: Map<string, AnalyticsPayload> = new Map()
    protected setLogger(loggerKey: string) {
        this.logger = getLogger(loggerKey).value
    }

    protected setInitialized(initialized: boolean) {
        this.initialized = initialized
        if (this.queue.size > 0) this.processQueue()
    }

    protected send(payloads: AnalyticsPayload[]) {
        this.logger.warn('send method not implemented for AnalyticsService', payloads)
    }

    public get isInitialized() {
        return this.initialized
    }

    public trackEvent(payload: AnalyticsPayload) {
        this.addToQueue(payload)
    }

    public trackEvents(payloads: AnalyticsPayload[]) {
        payloads.forEach(p => this.addToQueue(p))
    }

    private addToQueue(payload: AnalyticsPayload) {
        const { debounce_keys: debounceKeys = [], ...queuePayload } = payload
        const queueKey =
            queuePayload.event +
            '>' +
            (debounceKeys.length > 0
                ? debounceKeys.map(k => `${k}:${payload.params[k]}`).join('|')
                : JSON.stringify(queuePayload))

        this.queue.set(queueKey, payload)
        this.processQueue()
    }

    private processQueue() {
        if (!this.isInitialized) return
        if (this.queueProcessingTimeout) {
            clearTimeout(this.queueProcessingTimeout)
        }

        this.queueProcessingTimeout = setTimeout(() => {
            this.send(Array.from(this.queue.values()))
            this.queue.clear()
        }, TRACKING_TIMEOUT)
    }
}
